import PublicLayout from "../../layouts/publicLayout";
import { passwordRules } from "../../data/passwordRules";
import logo from "./../../assets/images/newLogo.png";
import { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  TextField,
  useMediaQuery,
  useTheme,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ComponentBackdrop from "../../components/backdrop";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";
import poisum from "./../../assets/images/poisum.png";

const ResetPassword = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [data, setData] = useState({
    newpassword: "",
    confirmpassword: "",
  });
  const [errors, setErrors] = useState({});
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const labelWidth = 170;
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const {
    apiUrls: { mobileApiUrl, accountMgtApiUrl },
  } = useApiClient();

  const validateNewPassword = (value) => {
    if (!value) return "This field is required.";
    if (value.length < 8) return "Password must be at least 8 characters";
    // if (!/[A-Z]/.test(value))
    //     return "Password must contain at least one uppercase letter";
    // if (!/[a-z]/.test(value))
    //     return "Password must contain at least one lowercase letter";
    // if (!/[0-9]/.test(value))
    //     return "Password must contain at least one number";
    // if (!/[!@#$%^&*(),.?":{}|<>]/.test(value))
    //     return "Password must contain at least one special character";
    return "";
  };

  const validateConfirmPassword = (value) => {
    if (!value) return "This field is required.";
    if (value !== data.newpassword) return "Both passwords should match.";
    return "";
  };

  const validate = (name, value) => {
    switch (name) {
      case "newpassword":
          return validateNewPassword(value);
      case "confirmpassword":
        return validateConfirmPassword(value);
      default:
        return "";
    }
  };

  const handleChange = (field, event) => {
    const value = event.target.value;

    setData({ ...data, [field]: value });
    if (field === "newpassword") {
        const error = validateNewPassword(value);
        setErrors((data) => ({ ...data, [field]: error }));
    }
    if (field === "confirmpassword") {
      const error = validateConfirmPassword(value);
      setErrors((data) => ({ ...data, [field]: error }));
    }
  };

const handleSubmit = async (event) => {
  event.preventDefault();
  setOpenBackdrop(true);

  try {

    const newErrors = Object.fromEntries(
      Object.entries(data)
        .map(([key, value]) => [key, validate(key, value)])
        .filter(([, error]) => error)
    );

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return; // stop if validation fails

    const employeeId = localStorage.getItem("employeeId");
    const tempPw = sessionStorage.getItem("tempPw");
    console.log('tempPw', tempPw);
    
    if (!employeeId || !tempPw) {
      toast.error("Something went wrong. Please retry login.");
      return;
    }

    const requestBody = {
      employeeId,
      oldPassword: tempPw,
      newPassword: data.newpassword,
    };
    console.log('mobileApiUrl reset pass page', mobileApiUrl);

    const changePwResponse = await api.put(
      `${mobileApiUrl}user/change-password`,
      requestBody
    );

    if (changePwResponse.status === 200) {
      sessionStorage.removeItem("tempPw");
      // console.log("success change password");
      toast.success("Password successfully changed.");

      const loginResponse = await api.post(
        `${accountMgtApiUrl}SourceUser/SourceUserLogin`,
        {
          username: localStorage.getItem("email"),
          password: data.newpassword,
          client_id: "poisum-mobile",
        }
      );
      
      const { access_token, refresh_token, user } = loginResponse?.data?.data || {};

      if (loginResponse.status === 200) {
        localStorage.setItem("token", access_token);
        localStorage.setItem("refreshToken", refresh_token);
        localStorage.setItem("employeeId", user.linked_user_id);

        const hasPermission = await checkPermissions(user);
        if (!hasPermission) {
          toast.error("You do not have the required permissions to access this portal.");
          navigate("/verifyEmail");
        } else {
          navigate("/summary");
        }
      }
    }
  } catch (error) {
    ErrorAlert(error, navigate);
  } finally {
    setOpenBackdrop(false);
  }
};

const checkPermissions = async (user, requiredRoles = ["Poisum Admin"]) => {
  try {
    const base = mobileApiUrl || process.env.REACT_APP_MOBILE_API_URL;
    if (!base) {
      console.error("checkPermissions: mobileApiUrl missing");
      return false;
    }

    // Ensure auth header if token exists
    const token = localStorage.getItem("token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    const url = `${base.replace(/\/+$/, "")}/user/user-permission`;
    const res = await api.get(url);

    // Normalize payload from different API shapes
    const payload = res?.data?.data ?? res?.data ?? {};

    // Aggregate possible role fields into a Set
    const rolesFound = new Set();

    const addRole = (r) => {
      if (!r && r !== 0) return;
      if (Array.isArray(r)) {
        r.forEach((x) => addRole(x));
      } else if (typeof r === "object") {
        // object like { name: '...' } or { roleName: '...' }
        addRole(r.name ?? r.roleName ?? r.role ?? "");
      } else {
        rolesFound.add(String(r).trim());
      }
    };

    addRole(payload.roleName ?? payload.role ?? payload.roles ?? payload.rolesName);
    addRole(payload.permissions ?? payload.allowedRoles ?? null);

    // Fallback: use the user object provided to the function
    if (user) {
      addRole(user.roleName ?? user.role ?? user.roles ?? null);
    }

    // Compare case-insensitively
    const foundArray = Array.from(rolesFound).filter(Boolean).map((r) => r.toLowerCase());
    const requiredLower = requiredRoles.map((r) => r.toLowerCase());
    const hasPermission = requiredLower.some((req) => foundArray.includes(req));

    return hasPermission;
  } catch (error) {
    console.error("checkPermissions error:", error);
    return false;
  }
};

  return (
    <PublicLayout>
       <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%", // Changed from 100vh to 100%
          maxWidth: { xs: "100%", md: 1100 },
          overflowY: "auto",
          boxShadow: { xs: "none", md: "0px 4px 20px rgba(0, 0, 0, 0.1)" },
          backgroundColor: 'background.main',
          borderRadius: { xs: "10px", md: "15px" },
          py: { xs: 4, sm: 8, md: 4 },
          px: { xs: 1, sm: 2, md: 12 },
          mx: { xs: 0, md: 2 },
          minHeight: { xs: "50vh", md: "auto" },
          height: { xs: "100%", sm: "90%", md: "650px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
            gap: { xs: 2, md: 4 }, // Added gap between logo and form
          }}
        >

       <Box
            sx={{
              display: "flex",
              position: "relative",
              borderRadius: "15px",
              p: { xs: 1, sm: 2, md: 4 }, // responsive padding
              width: "100%",
              maxWidth: { xs: 300, sm: 350, md: 400 }, // responsive width
              mx: "auto",
              // boxShadow: 2,
              mt: {xs: 3, sm: 5},
              height: { xs: 120, sm: 180, md: 250 }, // responsive height
              mb: { xs: 3, md: 4 },
            }}
          >

            {/* Faint Logo in Background */}
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: {
                  xs: 100, // smaller on mobile
                  sm: 160,
                  md: 200,
                  lg: 250,
                },
                height: "auto",
                zIndex: 0,
              }}
            />
             </Box>
          <Box
            sx={{
              backgroundColor: "#39483f43",
              borderRadius: '15px',
              py: { xs: 2, sm: 3, md: 4 },
              px: { xs: 2, sm: 4, md: 6 },
              width: { xs: "100%", sm: "90%", md: "380px" },
              height: "auto",
              maxWidth: { xs: "100%", sm: "480px" },
            }}
          >

        <Typography
          variant="title"
          display="block"
          fontWeight={600}
          gutterBottom
          textAlign="center"
          mb={3}
            textTransform={'uppercase'}
            sx={{color: '#fff'}}
        >
           POISUM portal
        </Typography>
           <Typography variant="subtitle" fontWeight={600} gutterBottom mb={1}  sx={{color: '#fff', mt: 2}} display="block">
              Reset Password
            </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
          autoComplete="off"
          >
            <Stack spacing={2} width="100%">
              <Box>
                <Typography
                  variant="body"
                  sx={{ minWidth: isMobile ? 0 : labelWidth, mb: 0.5, color: "#fff"  }} 
                  display="block"
                >
                  New Password
                </Typography>
                <TextField
                placeholder="Enter your new password"
                  id="newpassword"
                  name="newpassword"
                  type={showNewPassword ? "text" : "password"}
                  value={data.newpassword}
                  onChange={(e) => handleChange("newpassword", e)}
                  error={errors.newpassword}
                  helperText={errors.newpassword}
                  // margin="normal"
                  size="normal"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "transparent", // remove border if needed
                      },
                      "&:hover fieldset": {
                        borderColor: "primary.light", // optional on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "primary.main", // optional on focus
                      },
                    },
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowNewPassword((prev) => !prev)}
                            edge="end"
                          >
                            {!showNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </Box>
              {data.newpassword && errors.newpassword && (
                <Stack spacing={0.5} pl={2}>
                  {passwordRules.map((rule, idx) => {
                    const passed = rule.test(data.newpassword);
                    return (
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        key={idx}
                      >
                        {passed ? (
                          <CheckCircleIcon
                            fontSize="small"
                            sx={{ color: "success.main" }}
                          />
                        ) : (
                          <CancelIcon
                            fontSize="small"
                            sx={{ color: "error.main" }}
                          />
                        )}
                        <Typography
                          variant="note"
                          sx={{ color: passed ? "success.main" : "error.main" }}
                        >
                          {rule.label}
                        </Typography>
                      </Stack>
                    );
                  })}
                </Stack>
              )}
              <Box>
                <Typography
                  variant="body" 
                  display="block"
                  sx={{ minWidth: isMobile ? 0 : labelWidth, mb: 0.5, color: "#fff"  }}
                >
                  Confirm Password
                </Typography>
                <TextField
                  placeholder="Re-enter your new password"
                  id="confirmpassword"
                  name="confirmpassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={data.confirmpassword}
                  onChange={(e) => handleChange("confirmpassword", e)}
                  error={errors.confirmpassword}
                  helperText={errors.confirmpassword}
                  // margin="normal"
                  size="normal"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "transparent", // remove border if needed
                      },
                      "&:hover fieldset": {
                        borderColor: "primary.light", // optional on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "primary.main", // optional on focus
                      },
                    },
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowConfirmPassword((prev) => !prev)
                            }
                            edge="end"
                          >
                            {!showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </Box>
            </Stack>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{ backgroundColor: "primary.main", mt: 3, textTransform: "capitalize", fontSize: 14 }}
               endIcon={<CheckCircleIcon />}
            >
              Reset Password
            </Button>
          </Box>
          </Box>
        </Box>
      </Box>
      <Box
          component="img"
          src={poisum}
          alt="poisum"
          sx={{
              width:"100%",
              maxWidth:{ xs: "100%", md: 1000 },
              mt: { xs: -1.5, sm: -3.5, md: -6 }, // keep slight overlap
              mx: "auto",
              display: "block",
              opacity: 0.9, // optional like your screenshot
          }}
      />
      <ComponentBackdrop openBackdrop={openBackdrop} />
    </PublicLayout>
  );
};

export default ResetPassword;
